// utils/cookieUtils.ts

const CALLBACK_COOKIE = "request_callback_done";
const NOTIFY_COOKIE = "notify_checkup_done";

const IS_PROD = process.env.NODE_ENV === "production";
const COOKIE_DOMAIN = IS_PROD ? ".mysiponline.com" : undefined;

export function setRequestCallbackDone(): void {
  if (typeof document === "undefined") return;

  const domainPart = COOKIE_DOMAIN ? `; domain=${COOKIE_DOMAIN}` : "";

  document.cookie = `${CALLBACK_COOKIE}=true; path=/${domainPart}; max-age=${60 * 60 * 24 * 1}`; // 1 day
}

export function isRequestCallbackDone(): boolean {
  if (typeof document === "undefined") return false;

  return document.cookie.split("; ").some((c) => c.startsWith(`${CALLBACK_COOKIE}=true`));
}

export function setNotifyCheckUpDone(): void {
  if (typeof document === "undefined") return;

  const domainPart = COOKIE_DOMAIN ? `; domain=${COOKIE_DOMAIN}` : "";

  document.cookie = `${NOTIFY_COOKIE}=true; path=/${domainPart}; max-age=${60 * 60 * 24 * 3}`; // 1 day
}

export function isNotifyCheckUpDone(): boolean {
  if (typeof document === "undefined") return false;

  return document.cookie.split("; ").some((c) => c.startsWith(`${NOTIFY_COOKIE}=true`));
}
